import React, {useMemo} from "react"
import {styled} from "@mui/material"
import {getMerkmal} from "../../../misc/widget-functions"

export const lebenssituationBildProps = []

const BackgroundImage = styled("div")({
    backgroundSize: "cover",
    backgroundImage: "url(/lebenssituation-bild/Image_Container.svg)",
    backgroundRepeat: "no-repeat",
    width: "100%",
    aspectRatio: "614 / 375",
    position: "relative",
    boxShadow: "0px 5px 41.8px 0px rgba(67, 64, 64, 0.25)"
})

const baseProps = {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    position: "absolute",
}

const Woman = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/Object.svg)",
    height: "58%",
    aspectRatio: "65 / 235",
    bottom: "5%",
    right: "29%",
    left: "auto",
    top: "auto",
})

const Man = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/Object_3.svg)",
    height: "64%",
    aspectRatio: "78 / 249",
    bottom: "5%",
    right: "5%",
    left: "auto",
    top: "auto",
})

const Child = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/Object2.svg)",
    height: "50%",
    aspectRatio: "45 / 165",
    bottom: "5%",
    right: "18%",
    left: "auto",
    top: "auto",
})

const Dog = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/freepik--Dog--inject-727.svg)",
    height: "20%",
    aspectRatio: "106 / 92",
    bottom: "5%",
    right: "40%",
    left: "auto",
    top: "auto",
})

const House = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/Image_Group.svg)",
    height: "86%",
    aspectRatio: "329 / 343",
    bottom: "12%",
    right: "auto",
    left: "5%",
    top: "auto",
})

const Car = styled("div")({
    ...baseProps,
    backgroundImage: "url(/lebenssituation-bild/Object_car.svg)",
    height: "20%",
    aspectRatio: "76 / 66",
    bottom: "18.5%",
    right: "auto",
    left: "38%",
    top: "auto",
})


const familienstatusStates = [
    "PARTNERSCHAFT",
    "VERHEIRATET",
]

const hasPartner = (familienstatus) => familienstatusStates.includes(familienstatus)

const houseStates = [
    "HOME",
    "WOHNUNG",
]

const showHouse = (wohnsituation) => houseStates.includes(wohnsituation)

export const LebenssituationBild = ({
                                        getDataFromPointer,
                                        widget,
                                    }) => {
    const data = useMemo(
        () => {
            const pointer = getMerkmal(widget)?.pointer
            return (pointer ? getDataFromPointer(pointer) : null) ?? {}
        },
        [widget, getDataFromPointer],
    )

    const kinderData = useMemo(
        () => getDataFromPointer("/kinder"),
        [getDataFromPointer]
    )
    const {familienstand, anrede, hund, adresse, auto} = data
    const kinder = kinderData?.length;
    const isInteressentMale = useMemo(() => anrede !== "Frau", [anrede])
    const display = useMemo(() => ({
        woman: !isInteressentMale || hasPartner(familienstand),
        man: isInteressentMale || hasPartner(familienstand),
        child: Number.parseInt(kinder ?? "0") > 0,
        dog: hund,
        house: showHouse(adresse?.wohnsituation),
        car: auto,
    }), [isInteressentMale, familienstand, kinder, hund, adresse?.wohnsituation, auto])

    return <BackgroundImage>
        {display.man && <Man />}
        {display.woman && <Woman />}
        {display.child && <Child />}
        {display.dog && <Dog />}
        {display.house && <House />}
        {display.car && <Car />}
    </BackgroundImage>
}